import { Button, ButtonProps } from '@mui/material';
import { colors } from '../../../styles/theme/colors';

export type HeaderActionButtonProps = ButtonProps;

export function HeaderActionButton(props: HeaderActionButtonProps) {
    return (
        <Button
            variant="black"
            sx={{
                borderRadius: { xs: '50%', md: '2px' },
                padding: '6px',
                minWidth: 'unset',
                '&:hover': { backgroundColor: 'transparent', color: { md: colors.pink2 } },
            }}
            {...props}
        />
    );
}
